import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth';

const pageTitles: Record<string, string> = {
  '/': 'Tour de contrôle',
  '/activity': 'Activité récente',
  '/candidates': 'Gestion des candidats',
  '/employers': 'Gestion des recruteurs',
  '/admins': 'Comptes admin',
  '/offers': 'Gestion des offres',
  '/videos': 'Modération vidéo',
  '/music': 'Librairie musicale',
  '/subscriptions': 'Abonnements',
  '/reports': 'Signalements',
  '/referentials': 'Référentiels',
  '/command-board': 'Command Board',
  '/command-board/accounts': 'Comptes Seeds',
  '/command-board/offers': 'Offres Seeds',
  '/command-board/engagement': 'Engagement',
  '/command-board/analytics': 'Analytics',
  '/command-board/skill-families': 'Familles transversales',
  '/command-board/skill-proximity': 'Redondances',
  '/command-board/skill-usage': 'Usage compétences',
};

const Header: React.FC = () => {
  const [searchValue, setSearchValue] = useState('');
  const location = useLocation();
  const { user, signOut } = useAuth();

  const dynamicTitle = location.pathname.startsWith('/applications/')
    ? 'Détail candidature'
    : location.pathname.startsWith('/candidates/')
    ? 'Fiche candidat'
    : location.pathname.startsWith('/employers/')
    ? 'Fiche recruteur'
    : null;
  const title = dynamicTitle || pageTitles[location.pathname] || pageTitles[location.pathname.replace(/\/$/, '')] || 'Dashboard';

  return (
    <header className="h-16 bg-white border-b border-gray-200 flex items-center justify-between px-6 flex-shrink-0">
      <div>
        <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
      </div>

      <div className="flex-1 max-w-md mx-8">
        <div className="relative">
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm">🔍</span>
          <input
            type="text"
            placeholder="Rechercher un utilisateur, une offre..."
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            className="w-full pl-9 pr-4 py-2 bg-gray-50 border border-gray-200 rounded-lg text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#00244F]/20 focus:border-[#00244F] transition-all"
          />
        </div>
      </div>

      <div className="flex items-center gap-4">
        <button className="relative p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors">
          <span className="text-xl">🔔</span>
          <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
        </button>

        <div className="h-8 w-px bg-gray-200"></div>

        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-full bg-[#00244F] flex items-center justify-center text-white text-xs font-bold">
            {user?.email?.[0]?.toUpperCase() || 'A'}
          </div>
          <div className="hidden md:block">
            <p className="text-sm font-medium text-gray-700">{user?.email || 'Admin'}</p>
            <p className="text-xs text-gray-400">Administrateur</p>
          </div>
          <button
            onClick={signOut}
            className="ml-2 p-2 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-colors"
            title="Se déconnecter"
          >
            <span className="text-sm">🚪</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
